import { FC, ReactNode } from "react";
import styles from "@/css/Tooltip.module.css";
import { ClickPositionType } from "@/types/helperTypes";
import { useDarkModeContext } from "@/hooks/contextHooks/useDarkModeContext";

type Props = {
  data: {
    title: string;
    content: ReactNode;
  };
  clickPosition: ClickPositionType;
  action: VoidFunction;
};

export const TooltipComponent: FC<Props> = ({
  data,
  clickPosition,
  action,
}) => {
  const { isDarkMode } = useDarkModeContext();

  const textColor = isDarkMode ? "#201b41" : "#f0f0f0";

  const horizontal =
    clickPosition.x > window.innerWidth / 2
      ? { right: window.innerWidth - clickPosition.x }
      : { left: clickPosition.x };
  return (
    <div className={styles.container} onClick={action}>
      <div
        className={styles.tooltip}
        style={{
          ...horizontal,
          top: clickPosition.y,
          backgroundColor: isDarkMode ? "#f0f0f0" : "#201b41",
          color: textColor,
        }}
      >
        <h3>{data.title}</h3>
        <>{data.content}</>
      </div>
    </div>
  );
};
